// Some VexFlow versions draw ornaments as anonymous paths inside vf-modifiers.
// Add semantic groups while those modifiers draw, scoped to this OSMD instance.
const wrapped = new WeakSet();
export function groupOrnamentModifiers(sheet) {
  const seen = new Set();
  for (const page of sheet?.MusicPages || []) for (const system of page.musicSystems || [])
    for (const staves of system.graphicalMeasures || []) for (const measure of staves || [])
      for (const entry of measure?.staffEntries || []) for (const voice of entry.graphicalVoiceEntries || [])
        for (const graphicalNote of voice.notes || []) {
          const note=graphicalNote.vfnote?.[0];
          if(!note || seen.has(note))continue;
          seen.add(note);
          for(const modifier of note.getModifiers?.() || note.modifiers || []) {
            if(modifier.getCategory?.() !== 'ornaments' || wrapped.has(modifier) || typeof modifier.draw !== 'function')continue;
            const original=modifier.draw;
            modifier.draw=function(...args) {
              const context=this.getContext?.() || this.context;
              if(!context?.openGroup || !context?.closeGroup)return original.apply(this,args);
              const group=context.openGroup('ornament',this.getAttribute?.('id'),{pointerBBox:true});
              group?.setAttribute?.('data-score-symbol-type','ornament');
              try{return original.apply(this,args);}finally{context.closeGroup();}
            };
            wrapped.add(modifier);
          }
        }
}
export function renderWithOrnamentGroups(osmd) {
  const originals=new Map();
  const install=()=>{
    const drawer=osmd.Drawer || osmd.drawer;
    if(!drawer || typeof drawer.drawSheet !== 'function' || originals.has(drawer))return;
    const original=drawer.drawSheet;originals.set(drawer,original);
    drawer.drawSheet=function(sheet,...args){
      groupOrnamentModifiers(sheet || osmd.GraphicSheet);
      return original.call(this,sheet,...args);
    };
  };
  // OSMD can replace its drawer when refreshing the render backend.
  const refresh=osmd.createOrRefreshRenderBackend;
  if(typeof refresh==='function')osmd.createOrRefreshRenderBackend=function(...args){
    const result=refresh.apply(this,args);install();return result;
  };
  install();
  try{return osmd.render();}finally{
    if(typeof refresh==='function')osmd.createOrRefreshRenderBackend=refresh;
    for(const [drawer,original] of originals)drawer.drawSheet=original;
  }
}
export function classifyScoreSymbolElement(element,fallbackType) {
  if(element.closest?.('.vf-ornament, [data-score-symbol-type="ornament"]'))return 'ornament';
  const text=(element.textContent || '').trim().toLowerCase();
  if(text==='f' || text==='𝒇')return 'forte';
  if(text==='p' || text==='𝒑')return 'piano';
  if(text==='mf' || text==='𝒎𝒇')return 'mezzo-forte';
  if(text==='mp' || text==='𝒎𝒑')return 'mezzo-piano';
  return fallbackType;
}
